import { Action } from '@ngrx/store';
import {
    IAuthenticateRequest,
    IAuthenticateResponse
} from '../auth/authentication.service';
import { IRememberMe } from '../auth/IRememberMe';

export enum ActionTypes {
    Login = '[root] Login',
    Logout = '[root] Logout',
    Reset = '[root] Reset',
    GetVersion = '[root] GetVersion',
    VersionSuccess = '[root] VersionSuccess'
}

export class LoginAction implements Action {
    constructor(
        public payload: {
            req: IAuthenticateRequest | IRememberMe;
            resp: IAuthenticateResponse;
        }
    ) {}
    readonly type = ActionTypes.Login;
}

export class LogoutAction implements Action {
    readonly type = ActionTypes.Logout;
}

export class ResetAction implements Action {
    readonly type = ActionTypes.Reset;
}
export class GetVersionAction implements Action {
    readonly type = ActionTypes.GetVersion;
}
export class VersionSuccess implements Action {
    readonly type = ActionTypes.VersionSuccess;
    constructor(public payload: { version: string }) {}
}

export type ActionsUnion =
    | LogoutAction
    | LoginAction
    | ResetAction
    | GetVersionAction
    | VersionSuccess;
